export enum AsymmetryScalingVariableEnum {
  HORSE_RELATIVE_SCALED = 'horseRelativeScaled',
  MEAN_EXTREMES_DIFF_SCALED = 'meanExtremesDiffScaled',
}
